import React from 'react';

import {Row, Col} from "react-bootstrap";
import Form from "react-bootstrap/Form";

import "../css/Components.css";


const CLASS_OPTIONS = [
	{ value: '',  name: 'unknown'     },
	{ value: '1',  name: 'bhvādi'     },
	{ value: '2',  name: 'adādi'      },
	{ value: '3',  name: 'juhotyādi'  },
	{ value: '4',  name: 'divādi'     },
	{ value: '5',  name: 'svādi'      },
	{ value: '6',  name: 'tudādi'     },
	{ value: '7',  name: 'rudhādi'    },
	{ value: '8',  name: 'tanādi'     },
	{ value: '9',  name: 'kryādi'     },
	{ value: '10', name: 'curādi'     },
];

const ClassOptions=({updateInput})=>(
	<Form.Group>
		{CLASS_OPTIONS.map(({ value, name }) => (
			<Form.Check
				key={value}
				id={`lex_class_${value || 'unknown'}`}
				type="radio"
				label={`${value} ${name}`.trim()}
				name="lexClassOptions"
				onClick={()=>updateInput('class', value)}
			/>
		))}
	</Form.Group>
);

const TransitivityOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="lex_transitivity_i"
			type="radio"
			label="i intransitive"
			name="lexTransitivityOptions"
			onClick={()=>updateInput('transitivity', 'i')}
		/>
		<Form.Check 
			id="lex_transitivity_t"
			type="radio"
			label="t transitive"
			name="lexTransitivityOptions"
			onClick={()=>updateInput('transitivity', 't')}
		/>
	</Form.Group>
);

const VoiceOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="lex_voice_a"
			type="radio"
			label="a active"
			name="lexVoiceOptions"
			onClick={()=>updateInput('voice', 'a')}
		/>
		<Form.Check 
			id="lex_voice_m"
			type="radio"
			label="m middle"
			name="lexVoiceOptions"
			onClick={()=>updateInput('voice', 'm')}
		/>
		<Form.Check 
			id="lex_voice_p"
			type="radio"
			label="p passive"
			name="lexVoiceOptions"
			onClick={()=>updateInput('voice', 'p')}
		/>
	</Form.Group>
);

const LexVerb=({inputParts, setInputParts})=>{

	const updateInput=(key, value)=>{
		setInputParts((prev) => ({ ...prev, [key]: value }));
	}

	return (
		<>
		<Row>
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">P</span>art of speech
				</div>
				<Form.Group>
					<Form.Check 
						id="lex_pos_v"
						type="radio"
						label="v verb"
						name="lexPosOptions"
						checked={inputParts.pos === 'v' || inputParts.pos == null}
						onChange={()=>updateInput('pos', 'v')}
					/>
				</Form.Group>
			</Col>	
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">T</span>ransitivity
				</div>
				<TransitivityOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md={4} className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">C</span>lass
				</div>
				<ClassOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">V</span>oice
				</div>
				<VoiceOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
		</Row>
		
		</>
	);
};

export default LexVerb;